module.exports = __webpack_public_path__ + "static/img/pic22.1.5a4433e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic22.1.png
// module id = 0EMa
// module chunks = 0